<template>
  <div>
    <TheHeader farming></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">Q&amp;A</TextHeading>
      <TextHeading variant="xl">Woodheads Livestock</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
      </PageSide>
      <PageMain>
        <TextAccordion :items="accordionItems"/>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>
<script>
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import PageGrid from '../elements/PageGrid.vue'
import TheFooter from '../components/TheFooter.vue'
import PageMain from '../elements/PageMain.vue'
import TheHeader from '../components/TheHeader.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageHeader from '../components/PageHeader.vue'
import TextHeading from '../elements/TextHeading.vue'
import TextAccordion from '../components/TextAccordion.vue'
export default {
  name: 'FarmingWoodheadsLivestock',
  components: {
    BreadcrumbBar,
    TheHeader,
    PageMain,
    TheFooter,
    PageGrid,
    PageHeader,
    TextHeading,
    PageSide,
    SideNav,
    TextAccordion
  },
  data() {
    return {
      accordionItems: [
        {
          category: 'Sending livestock',
          title: "I've never sent livestock to you before – how do I start?",
          value:
            '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo.</p><p>Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.</p>',
          linktext: '',
          link: ''
        },
        {
          category: 'Sending livestock',
          title: 'How do I contact a buyer?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Sending livestock',
          title: 'Will someone come to look at my livestock?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Sending livestock',
          title: 'How do I book my livestock in?',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Confirmation of livestock booking',
          title: 'Question One',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Confirmation of livestock booking',
          title: 'Question Two',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Confirmation of livestock booking',
          title: 'Question Three',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Changes to existing supplier',
          title: 'Question One',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Changes to existing supplier',
          title: 'Question Two',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        },
        {
          category: 'Changes to existing supplier',
          title: 'Question Three',
          value:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eu eros in turpis auctor commodo. Aliquam aliquet, elit ac consectetur lobortis, velit felis iaculis lorem.',
          linktext: '',
          link: ''
        }
      ]
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>